import React from 'react';
import { createRoot } from 'react-dom/client';
import GISMap from './components/GISMap';
import FilterPanel from './components/FilterPanel';
import InfoPanel from './components/InfoPanel';
import LayerControl from './components/LayerControl';
import './styles/main.css';

/**
 * Инициализация Standalone GIS Widget
 * @param {string} containerId - ID контейнера div, в который будет встроена ГИС
 * @param {Object} options - Опции конфигурации
 * @param {string} options.apiUrl - URL бэкенда (по умолчанию: 'http://localhost:3000')
 * @param {Array<number>} options.defaultCenter - Центр карты [x, y] в EPSG:3857 (по умолчанию: [3500000, 8350000])
 * @param {number} options.defaultZoom - Зум по умолчанию (по умолчанию: 7)
 */
function initGIS(containerId, options = {}) {
  const {
    apiUrl = 'http://localhost:3000',
    defaultCenter = [3500000, 8350000],
    defaultZoom = 7
  } = options;

  // Проверка наличия контейнера
  const container = document.getElementById(containerId);
  if (!container) {
    console.error(`Container with id "${containerId}" not found`);
    return null;
  }

  // Создание корневого элемента React
  const root = createRoot(container);
  
  // Рендеринг основного компонента
  root.render(
    <GISWidget
      apiUrl={apiUrl}
      defaultCenter={defaultCenter}
      defaultZoom={defaultZoom}
    />
  );

  return {
    destroy: () => {
      root.unmount();
    }
  };
}

/**
 * Основной компонент виджета
 */
function GISWidget({ apiUrl, defaultCenter, defaultZoom }) {
  const [selectedArea, setSelectedArea] = React.useState(null);
  const [filters, setFilters] = React.useState({
    region: null,
    users: null,
    ecos: null,
    lands: null
  });
  const mapRef = React.useRef(null);
  const mapLayerManagerRef = React.useRef(null);

  return (
    <div className="gis-widget">
      <div className="gis-widget__sidebar">
        <FilterPanel
          apiUrl={apiUrl}
          filters={filters}
          onFiltersChange={setFilters}
          onAreaSelect={setSelectedArea}
          mapRef={mapRef.current}
          layerManagerRef={mapLayerManagerRef}
        />
        <InfoPanel
          apiUrl={apiUrl}
          selectedArea={selectedArea}
        />
      </div>
      <div className="gis-widget__map-container">
        <GISMap
          ref={mapLayerManagerRef}
          apiUrl={apiUrl}
          defaultCenter={defaultCenter}
          defaultZoom={defaultZoom}
          filters={filters}
          selectedArea={selectedArea}
          onMapReady={(olMap) => {
            mapRef.current = olMap;
          }}
        />
        <LayerControl
          apiUrl={apiUrl}
          layerManagerRef={mapLayerManagerRef}
        />
      </div>
    </div>
  );
}

// Экспорт функции инициализации
if (typeof window !== 'undefined') {
  window.GISWidget = {
    initGIS
  };
}

export { initGIS };
export default GISWidget;


